import React from "react";
import Container from "@mui/material/Container";
import {Link } from "@mui/material";
// import { Link } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {QFlowLogoSVG} from "../components/img/QFlowLogoSVG";
import Divider from "@mui/material/Divider";
import {Typography} from "@mui/material";


const Soc2Logo = "/images/qflow-is-soc2-certified.png"
export default function UnauthenticatedFooter() {

    return (
        <div style={{
            // position: 'absolute',
            bottom: 0, width: "100%",
            backgroundColor: '#fff'
        }}>
            <Container sx={{
                fontSize: "14px",
                paddingBottom: "5em",
                width: '100vw',
                paddingTop: 'calc(1% + 60px)',
                backgroundColor: '#fff',
                border: 0,
                color: "primary",
                flexGrow: 1,
                maxWidth: 'xl',
                // component:'div',
                // maxWidth:'auto',
                // backgroundImage: {HomepageHeroSVG},

                // backgroundImage: '#272931',
                fontFamily: [
                    'Assistant, sans-serif',
                    '-apple-system',
                    'BlinkMacSystemFont',
                    '"Segoe UI"',
                    'Helvetica Neue',
                    'Arial',
                    'sans-serif',
                    '"Apple Color Emoji"',
                    '"Segoe UI Emoji"',
                    '"Segoe UI Symbol"',
                ].join(','),
            }}>
                <Divider
                    sx={{
                        backgroundColor: "primary"
                    }}
                    variant="fullWidth"/>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={3}>
                        <Grid container direction="column" spacing={1} alignItems="flex-start">
                            <Grid item><Box paddingTop="3.35em"/></Grid>
                            <Grid item>
                                <QFlowLogoSVG width='7em' color='#272931'/>
                            </Grid>
                            <Grid item>
                                &copy; QFlow.ai,
                                Inc.&trade; {new Date().toLocaleDateString(undefined, {year: "numeric"})}
                            </Grid>

                            <Grid item>
                                San Francisco, California
                            </Grid>

                            <Grid item>
                               <Link href={"https://trust.qflow.ai"}> <img alt="QFlow is SOC 2 Certified" src={Soc2Logo} width={145}/></Link>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <Grid container direction="column" spacing={2} alignItems="flex-start">
                            <Grid item>
                                <Box paddingTop="3.35em"/>
                            </Grid>
                            <Grid item>
                                <Typography
                                    style={{fontSize: 'inherit', textTransform: 'uppercase'}}>Product</Typography>
                            </Grid>
                            <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}}
                                      href="/products/go-to-market-stats">
                                    Go-to-Market Stats
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}}
                                      href="/products/multi-quarter-projections">
                                    Multi-quarter Revenue Projections
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}} href="/products/forecasting">
                                    In-quarter Sales Forecasting
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}} href="/products/revenue-forecasting">
                                    Revenue Forecasting
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}}
                                      href="/products/machine-learning">
                                    QPilot (AI Analyst)
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}}
                                      href="/products/business-digest">
                                    Business Digest
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}}
                                      href="/products/account-based-attribution">
                                    Multi-touch Attribution
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}}
                                      href="/products/campaign-measurement">
                                    Campaign Effectiveness
                                </Link>
                            </Grid>

                            <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}}
                                      href="/products/inbound-lead-response-measurement">
                                    GTM Signal Response Measurement
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}}
                                      href="/products/sales-activity">
                                    Activity & Capacity Analytics
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}}
                                      href="/products/rep-ramp">
                                    Rep Ramp Management
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}}
                                      href="/products/sales-pipeline-analytics">
                                    Pipeline Forensics
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}} href="/products/integrations">
                                    QFlow Connect
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}} href="/desktop">
                                    QFlow Desktop
                                </Link>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={2}>
                        <Grid container direction="column" spacing={2} alignItems="flex-start">
                            <Grid item>
                                <Box paddingTop="3.35em"/>
                            </Grid>
                            <Grid item>
                                <Typography
                                    style={{fontSize: 'inherit', textTransform: 'uppercase'}}>Company</Typography>
                            </Grid>
                            {/*<Grid item>*/}
                            {/*    About*/}
                            {/*</Grid>*/}
                            <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}}
                                      href="/about">
                                    About
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}}
                                      href="https://blog.qflow.ai">
                                    Blog
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}}
                                      href="/partners">
                                    Partners
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}}
                                      to={`/careers`}>
                                    Careers
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}}
                                      to={`/faq`}>

                                    Support
                                </Link>
                            </Grid>
                             <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}}
                                      href={`https://status.qflow.ai`}>
                                    Service Status
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}} href="/pricing">
                                    Pricing
                                </Link>
                            </Grid>
                            <Grid item>&nbsp;</Grid>
                            <Grid item>
                                <Typography style={{fontSize: 'inherit', textTransform: 'uppercase'}}>QFlow
                                    Benefits</Typography>
                            </Grid>
                            <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}}
                                      href="/solutions/finance">
                                    For Finance Teams
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}}
                                      href="/solutions/revenue-operations">
                                    For Revenue Operations
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}} href="/solutions/sales">
                                    For Sales
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}} href="/solutions/marketing">
                                    For Marketing
                                </Link>
                            </Grid>

                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <Grid container direction="column" spacing={2} alignItems="flex-start">
                            <Grid item>
                                <Box paddingTop="3.35em"/>
                            </Grid>
                            <Grid item>
                                <Typography style={{fontSize: 'inherit', textTransform: 'uppercase'}}>Legal &
                                    Security</Typography>
                            </Grid>
                                 <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}} href="https://trust.qflow.ai">
                                    Trust Portal
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}} href="/service-terms">
                                    Service Terms & Privacy Policy
                                </Link>
                            </Grid>

                            <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}} href="/security">
                                    Security, Privacy, and Architecture
                                </Link>
                            </Grid>
                            <Grid item>&nbsp;</Grid>
                            <Grid item>
                                <Typography
                                    style={{fontSize: 'inherit', textTransform: 'uppercase'}}>Contact</Typography>
                            </Grid>
                            <Grid item>
                                <Link sx={{pointer: "cursor"}} color="primary" style={{textDecoration: "none"}} href="/contact-us" component={Link}  data-cal-config='{"layout":"month_view"}' data-cal-namespace="">
                                    Book a Demo
                                </Link>
                            </Grid>
                            <Grid item>
                                <Link color="primary" style={{textDecoration: "none"}} href="tel:+14157356910">
                                    +1 (415) 735-6910
                                </Link>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {/*<CookieConsent*/}
                {/*      expires={10}*/}
                {/*    style={{backgroundColor: '#fff', color: '#4f515b'}}*/}
                {/*buttonStyle={{backgroundColor: '#579FEE', color: '#fff', borderRadius: '2px'}}*/}
                {/*>This website uses cookies to enhance user experience. By continuing to use this website, you agree to their use.</CookieConsent>*/}

            </Container>
        </div>

    )
}
